import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=7ab33fca&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"
import style0 from "./Stats.vue?vue&type=style&index=0&id=7ab33fca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab33fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab33fca')) {
      api.createRecord('7ab33fca', component.options)
    } else {
      api.reload('7ab33fca', component.options)
    }
    module.hot.accept("./Stats.vue?vue&type=template&id=7ab33fca&scoped=true", function () {
      api.rerender('7ab33fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoCard/Stats.vue"
export default component.exports